export default {
  /* Events */
  assistantsExportedSuccessfully: 'सहायकों का सफलतापूर्वक निर्यात',
  createEvent: 'घटना बनाएं',
  mustChargeBeforeCreateEvents: 'ईवेंट बनाने से पहले आपको पैसे वसूलने होंगे',
  events: 'घटनाओं',
  published: 'प्रकाशित',
  notPublished: 'प्रकाशित नहीं',
  soldOut: 'बिक गया',
  publishEventToBeShownInSalesLists: 'बिक्री सूचियों में दिखाए जाने वाले इस ईवेंट को प्रकाशित करें',
  loadingEvents: 'लोडिंग इवेंट',
  noEventsRegistered: 'कोई घटना पंजीकृत नहीं',
  publish: 'प्रकाशित',
  soldTickets: 'बेचे गए टिकट',
  availableTickets: 'उपलब्ध टिकट',
  totalTickets: 'टिकट राशि',
  eventStateUpdated: 'घटना राज्य अद्यतन',
  profileImage: 'प्रोफाइल इमेज',
  thePicture: 'तस्वीर',
  thePictures: 'तस्वीरें',
  theBanner: 'बैनर',
  eventRating: 'घटना की रेटिंग',
  priceRating: 'मूल्य रेटिंग',
  profitability: 'लाभप्रदता',
  businessFee: 'व्यवसाय शुल्क',
  gatewayFee: 'गेटवे शुल्क',
  totalProfit: 'कुल लाभ',
  tags: 'टैग',
  createTag: 'टैग बनाएं',
  purchase: 'खरीद फरोख्त',
  /* End Events */
  createPromotor: 'प्रमोटर बनाएं',
  mustChargeBeforeCreatingPromotors: 'प्रमोटर बनाने से पहले आपको पैसे चार्ज करने चाहिए',
  promotors: 'प्रमोटरों',
  showUrlToPromotor: 'प्रमोटर को यूआरएल दिखाएं',
  editPromotor: 'प्रमोटर संपादित करें',
  setProfilePicture: 'प्रोफाइल पिक्चर सेट करें',
  setBanner: 'बैनर सेट करें',
  deletePromotor: 'प्रमोटर हटाएं',
  loadingPromotor: 'लोडिंग प्रमोटर',
  noPromotorsRegistered: 'पंजीकृत प्रमोटर नहीं हैं',
  createProductsCategory: 'उत्पाद बनाएं',
  mustChargeBeforeCreatingProductsCategories: 'उत्पाद बनाने से पहले आपको पैसे वसूलने चाहिए',
  successfullyCreatedProductCategory: 'उत्पाद सफलतापूर्वक बनाया गया',
  successfullyUpdatedProductCategory: 'उत्पाद सफलतापूर्वक अपडेट किया गया',
  productsCategories: 'उत्पादों',
  newProductsCategory: 'नया उत्पाद',
  editProductsCategory: 'उत्पाद को संपादित करें',
  photos: 'तस्वीरें',
  setProductsCategoryPhoto: 'उत्पाद फोटो सेट करें',
  deleteProductsCategory: 'उत्पाद हटाएं',
  loadingProductsCategory: 'उत्पादों को लोड करना',
  noProductsCategoriesRegistered: 'ऐसे उत्पाद पंजीकृत नहीं हैं',
  doYouWantToDeleteProductsCategory: 'क्या आप उत्पाद को हटाना चाहते हैं?',
  price: 'मूल्य',
  discountPrice: 'डिस्काउंट प्राइस',
  stock: 'भंडार',
  createProduct: 'उत्पाद बनाएं',
  mustChargeBeforeCreatingProducts: 'उत्पाद बनाने से पहले आपको पैसे वसूलने चाहिए',
  products: 'उत्पादों',
  newProduct: 'नया उत्पाद',
  editProduct: 'उत्पाद को संपादित करें',
  // // photos: 'तस्वीरें',
  setProductPhoto: 'उत्पाद फोटो सेट करें',
  deleteProduct: 'उत्पाद हटाएं',
  loadingProduct: 'उत्पादों को लोड करना',
  noProductsRegistered: 'ऐसे उत्पाद पंजीकृत नहीं हैं',
  doYouWantToDeleteProduct: 'क्या आप उत्पाद को हटाना चाहते हैं?',
  purchaseId: 'id',
  purchasePaymentMethod: 'भुगतान के तरीके',
  shippingAddress: 'शिपिंग पता',
  paymentDate: 'भुगतान तिथि',
  createProductPurchase: 'उत्पाद खरीद बनाएं',
  mustChargeBeforeCreatingProductPurchases: 'उत्पाद खरीद करने से पहले आपको पैसे वसूलने चाहिए',
  productPurchases: 'उत्पाद खरीद',
  newProductPurchase: 'नई उत्पाद खरीद',
  editProductPurchase: 'उत्पाद खरीद को संपादित करें',
  deleteProductPurchase: 'उत्पाद खरीद हटाएं',
  loadingProductPurchase: 'उत्पाद की खरीदारी लोड करना',
  noProductPurchasesRegistered: 'उत्पाद खरीदारियां पंजीकृत नहीं हैं',
  doYouWantToDeleteProductPurchase: 'क्या आप उत्पाद खरीद को हटाना चाहते हैं?',
  provider: 'प्रदाता',
  providers: 'प्रदाताओं',
  createProvider: 'प्रदाता बनाएं',
  mustChargeBeforeCreatingProviders: 'आपको प्रदाता बनाने से पहले पैसे चार्ज करने चाहिए',
  newProvider: 'नया प्रदाता',
  editProvider: 'संपादित प्रदाता',
  deleteProvider: 'प्रदाता को हटाएं',
  loadingProvider: 'लोडिंग प्रदाता',
  noProvidersRegistered: 'पंजीकृत प्रदाता नहीं हैं',
  doYouWantToDeleteProvider: 'क्या आप प्रदाता को हटाना चाहते हैं?',
  providerHasBeenDeleted: 'प्रदाता को सफलतापूर्वक हटा दिया गया है',
  fabric: 'कपड़ा',
  fibre: 'फाइबर',
  key: 'कुंजी',
  positionArc: 'स्थिति आर्क',
  acab: 'अहाब',
  acabado: 'समाप्त',
  refChina: 'संदर्भ चीन',
  refClient: 'संदर्भ ग्राहक',
  label: 'लेबल',
  wide: 'विस्तृत',
  weight: 'वजन',
  composition: 'संरचना',
  perfomance: 'पर्फोमेंस',
  unitMeasure: 'यूनिट उपाय',
  cantMtsFinals: 'खिचड़ी: एमटीएस फाइनल',
  cantKlsFinals: 'खिचड़ी: Kls फाइनल',
  cantMtKl: 'खिचड़ी: माउंट Kl',
  capMaxKl: 'कैप मैक्स केएल',
  portOcupation: 'पोर्ट ऑक्यूपेशन',
  productHasBeenDeleted: 'उत्पाद को सफलतापूर्वक हटा दिया गया है',
  attachEventsInYourWebSite: 'अपनी वेब साइट में घटनाओं डालें',
  createDivElementToAttachEventsInYourWebSite: 'अपनी वेब साइट पर ईवेंट संलग्न करने के लिए. आपको आईडी के साथ एक div तत्व बनाना होगा',
  andOtherWithTheId: 'और आईडी के साथ अन्य',
  inYourSiteBody: 'अपनी वेबसाइट साइट के बॉडी टैग में',
  andThenAddTheNextScriptInTheFooter: 'और फिर अपनी साइट के पाद लेख में अगली स्क्रिप्ट जोड़ें',
  scriptCopied: 'स्क्रिप्ट की नकल',
  errorCopyingTheScript: 'स्क्रिप्ट की नकल करने में त्रुटि',
  exportAssistants: 'निर्यात सहायक',
  assistantsList: 'सहायकों की सूची',
  assistantId: 'सहायक की आईडी',
  loadingAssistants: 'लोडिंग सहायक',
  noAssistantsRegistered: 'पंजीकृत सहायक नहीं हैं',
  registerDate: 'रजिस्टर तिथि',
  automatic: 'स्वचालित',
  manual: 'मैनुअल',
  creationType: 'सृजन प्रकार',
  errorLoadingEvent: 'घटना को लोड करने में एक त्रुटि थी',
  eventNotPublishedAndOutOfLists: 'आपका ईवेंट प्रकाशित नहीं किया गया है. और यह सूचियों में तब तक नहीं देखा जा रहा है जब तक कि यह नहीं हो जाता',
  eventDate: 'घटना की तारीख',
  publishEvent: 'घटना प्रकाशित',
  seePromotorInYourWebSite: 'अपनी वेब साइट में प्रमोटर देखें',
  mustDoToSeePromotorInWebSite: 'प्रमोटर को देखने के लिए. आपको अगले यूआरएल में प्रवेश करने के लिए. अपनी वेबसाइट में संलग्न घटनाओं विजेट होना सुनिश्चित करना होगा',
  copy: 'प्रतिलिपि',
  mustContactSupportToSeePromotorInWebSite: 'प्रमोटर को देखने के लिए. यूआरएल प्राप्त करने के लिए आपको समर्थन से संपर्क करना होगा',
  errorCopyingUrl: 'यूआरएल की नकल करने में त्रुटि',
  urlCopied: 'यूआरएल कॉपी किया गया',
  eventContacts: 'घटना संपर्क',
  doYouWantToDeletePromotor: 'क्या आप प्रमोटर को हटाना चाहते हैं?',
  /* Djs */
  view: 'राय',
  djSuccessfullyCreated: 'Dj सफलतापूर्वक बनाया गया',
  djSuccessfullyUpdated: 'Dj सफलतापूर्वक अपडेट किया गया',
  createDj: 'Create dj',
  mustChargeBeforeCreatingDjs: 'Djs बनाने से पहले आपको पैसे चार्ज करने होंगे',
  djs: 'Djs',
  followers: 'अनुयायियों',
  showUrlToDj: 'Url को dj को दिखाएँ',
  editDj: 'dj संपादित करें',
  deleteDj: 'डी जे हटाओ',
  loadingDj: 'लोडिंग डीजे',
  noDjsRegistered: 'वहाँ djs पंजीकृत नहीं हैं',
  doYouWantToDeleteDj: 'क्या आप dj को हटाना चाहते हैं?',
  seeDjInYourWebSite: 'अपनी वेब साइट में dj देखें',
  mustDoToSeeDjInWebSite: 'Dj देखने के लिए, आपको अगली वेबसाइट में प्रवेश करने के लिए अपनी वेबसाइट में ईवेंट विजेट संलग्न करना सुनिश्चित करना चाहिए',
  mustContactSupportToSeeDjInWebSite: 'Dj देखने के लिए, आपको url प्राप्त करने के लिए समर्थन से संपर्क करना चाहिए',
  /* End Djs */
  importAssistants: 'आयात सहायक',
  event: 'घटना',
  assistantsImportedSuccessfully: 'सहायकों का सफलतापूर्वक आयात किया गया',
  format: 'स्वरूप',
  editEvent: 'घटना को संपादित करें',
  newEvent: 'नई घटना',
  shortDescription: 'संक्षिप्त विवरण',
  note: 'नोट',
  insertNoteToSendInConfirmationEmail: 'पुष्टिकरण ईमेल में भेजने के लिए एक नोट डालें',
  isAnOnlineEvent: 'यह एक ऑनलाइन घटना है',
  eventUrl: 'इवेंट का यूआरएल',
  category: 'श्रेणी',
  startDate: 'प्रारंभ तिथि',
  finishDate: 'खत्म करने की तारीख',
  startDateAccess: 'प्रारंभ तिथि',
  finishDateAccess: 'खत्म करने की तारीख',
  /* Places */
  place: 'जगह',
  latitude: 'अक्षांश',
  longitude: 'देशांतर',
  organizer: 'आयोजक',
  limitRegisterByIdentificationDocument: 'पहचान दस्तावेज द्वारा रजिस्टर की सीमा',
  cover: 'आवरण',
  pictures: 'तस्वीरें | फोटो',
  eventCreated: 'बनाई गई घटना',
  promoter: 'प्रमोटर',
  locationUrl: 'स्थान के लिए यूआरएल',
  facebookMessageSendingUrl: 'यूआरएल भेजने का फेसबुक संदेश',
  facebookSiteUrl: 'फेसबुक साइट यूआरएल',
  completeRequiredFields: 'आवश्यक फ़ील्ड को पूरा करें',
  promoterSuccessfullyCreated: 'प्रमोटर सफलतापूर्वक बनाया गया था',
  promoterSuccessfullyUpdated: 'प्रमोटर को सफलतापूर्वक अपडेट किया गया',
  eventSocialNetworks: 'घटना सामाजिक नेटवर्क',
  socialNetworkSelect: 'सोशल नेटवर्क का चयन करें',
  urlOrLink: 'यूआरएल या लिंक',
  socialNetworkAdd: 'सोशल नेटवर्क जोड़ें',
  eventCurrency: 'इवेंट करेंसी',
  ticketTitle: 'टिकट शीर्षक',
  ticketPrice: 'टिकट की कीमत',
  ticketingServicePrice: 'टिकटिंग सेवा मूल्य',
  startOfSale: 'बिक्री की शुरुआत',
  endOfSale: 'बिक्री का अंत',
  ticketsNumber: 'टिकटों की संख्या',
  maxTicketsPerPerson: 'प्रति व्यक्ति टिकटों की अधिकतम संख्या',
  deleteTicket: 'टिकट हटाएं',
  addTicket: 'टिकट जोड़ें',
  result: 'परिणाम',
  ofPromoter: 'प्रमोटर की',
  upload: 'अपलोड',
  allowedFormats: 'केवल इन प्रारूपों की अनुमति है',
  maxPictureSize: 'चित्र का अधिकतम आकार होना चाहिए',
  and: 'और',
  dragAndDropFile: 'यहां फ़ाइल खींचें और छोड़ दें',
  imageSuccessfullyLoaded: 'छवि सफलतापूर्वक भरी हुई',
  deleteSelection: 'चयन हटाएं',
  analyze: 'विश्लेषण',
  atLeastOneFileToContinue: 'जारी रखने के लिए कम से कम एक फ़ाइल दर्ज करें',
  nextStep: 'अगला कदम',
  theFile: 'फाइल',
  notAccepted: 'स्वीकार नहीं किया गया',
  seeEvent: 'घटना देखें',
  registerAttender: 'रजिस्टर सहायक',
  advancedSearch: 'उन्नत खोज',
  assistantsPerPage: 'प्रति पेज सहायक',
  assistantName: 'सहायक नाम',
  creation: 'निर्माण',
  ticket: 'टिकट',
  register: 'पंजीकृत करें',
  assistantRegistered: 'सहायक पंजीकृत',
  buyer: 'खरीदार',
  cost: 'लागत',
  parallelAnswer: 'समानांतर उत्तर',
  franchise: 'मताधिकार',
  bank: 'बैंक',
  ofPurchase: 'खरीद की',
  download: 'डाउनलोड',
  dataCopied: 'डेटा कॉपी किया गया',
  errorTryAgain: 'एक त्रुटि हुई. फिर से प्रयास करें',
  checkInState: 'चेक-इन राज्य',
  check: 'चेक',
  checkedIn: 'आगमन की सूचना दिया',
  unCheck: 'अनचेक करें',
  doYouWantDuplicate: 'क्या आप इस जगह की नकल करना चाहते हैं?',
  isPlaceActive: 'क्या यह जगह सक्रिय है?',
  isThisPlaceRestaurant: 'यह जगह एक रेस्तरां है',
  configPlace: 'जगह सेटिंग',
  placeRating: 'रैंकिंग रखें',
  placeTags: 'अपनी जगह का टैग',
  tagsHint: 'एक टैग टाइप करें, फिर Enter दबाएँ',
  pleaseTypeLocation: 'कृपया अपना पता लिखें',
  diningStyle: 'भोजन शैली',
  dressCode: 'ड्रेस कोड',
  acceptedPaymentMethods: 'स्वीकृत भुगतान विधियां',
  parkingType: 'पार्किंग का प्रकार',
  casual: 'Casual',
  businessCasual: 'Business casual',
  casualElegant: 'Casual elegant',
  formal: 'Formal',
  jacketRequired: 'Jacket required',
  jacketAndTie: 'Jacket and tie',
  priceAverage: 'मूल्य औसत',
  brunch: 'ब्रंच',
  lunch: 'दोपहर का भोजन',
  happyHour: 'हैप्पी आर',
  dinner: 'रात का खाना',
  daily: 'रोज',
  zipCode: 'पिन कोड',
  currency: 'मुद्रा'
  /* End Places */
}
